"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _uuid = require('shared/services/uuid');
var _string = require('shared/services/string');
var _uploadFailure = require('shared/services/uploadFailure');


































































const initialState = {}



/* Shows a text the patient sent (or wrote offline) in sendState: the row
 * with this lid when it is a retry, otherwise a new newest row. */
const showSend = (
  state,
  { Text, ConversationKey, PatientKey, MessageKey, ReplyToMessageKey },
  lid,
  sendState,
  globalState,
) => {
  const messages = state[ConversationKey]
  if (!messages) return state

  if (messages.some(m => m.LocalKey === lid)) {
    return {
      ...state,
      [ConversationKey]: messages.map(m => m.LocalKey === lid ? { ...m, SendState: sendState } : m),
    }
  }

  // An ISO time, so the row sorts with the server's messages.
  const row = {
    TextContent: Text,
    SentTimestamp: new Date().toISOString(),
    MessageKey: _nullishCoalesce(MessageKey, () => ( `temp-${_uuid.uuidv4.call(void 0, )}`)),
    LocalKey: lid,
    SendState: sendState,
    ReplyToMessageKey,
  }

  if (globalState.currentUser.UserKey) row.FromUserKey = globalState.currentUser.UserKey
  else if (PatientKey) row.FromPatientKey = PatientKey

  return {
    ...state,
    [ConversationKey]: [row, ...messages],
  }
}

const setSendState = (
  state,
  conversationKey,
  matches,
  sendState,
) => {
  const messages = state[conversationKey]
  if (!_optionalChain([messages, 'optionalAccess', _ => _.some, 'call', _2 => _2(matches)])) return state
  return {
    ...state,
    [conversationKey]: messages.map(m => matches(m) ? { ...m, SendState: sendState } : m),
  }
}

/* The counts with the patient's own Emoji added (mine) or taken away. A
 * count that reaches 0 goes; a new emoji goes last, as the server orders
 * them by first use. */
const toggleOwnReaction = (reactions, emoji, mine) => {
  const existing = reactions.find(r => r.Emoji === emoji)
  if (mine) {
    if (_optionalChain([existing, 'optionalAccess', _3 => _3.Mine])) return reactions
    return existing
      ? reactions.map(r => r === existing ? { ...r, Count: r.Count + 1, Mine: true } : r)
      : [...reactions, { Emoji: emoji, Count: 1, Mine: true }]
  }
  if (!_optionalChain([existing, 'optionalAccess', _4 => _4.Mine])) return reactions
  return existing.Count > 1
    ? reactions.map(r => r === existing ? { ...r, Count: r.Count - 1, Mine: false } : r)
    : reactions.filter(r => r !== existing)
}

/* Inserts a message by its time, or replaces the row it changes: a staff
 * recall, a resend with new reactions, or the server's copy of a row the
 * page sent. */
const placeMessage = (
  state,
  newMessage,
  findRow,
) => {
  const messages = state[newMessage.ConversationKey] || []

  const existing = messages.findIndex(m => (_optionalChain([findRow, 'optionalCall', _5 => _5(m)])) || m.MessageKey === newMessage.MessageKey)
  if (existing !== -1) {
    const updated = [...messages]
    updated[existing] = newMessage
    return {
      ...state,
      [newMessage.ConversationKey]: updated,
    }
  }

  const sentTime = newMessage.SentTimestamp
  let insertPos = 0
  // Compares a stored (string or optimistic numeric) timestamp with a
  // string, as the JS did.
  while (messages[insertPos] && (messages[insertPos].SentTimestamp ) > sentTime) {
    insertPos++
  }

  return {
    ...state,
    [newMessage.ConversationKey]: [...messages.slice(0, insertPos), newMessage, ...messages.slice(insertPos)],
  }
}

const combineOldAndNewMessages = (
  oldMessages,
  newMessages,
  ck,
) => {
  const messageDedupeMap = {}

  if (oldMessages[ck]) {
    oldMessages[ck].forEach((m) => messageDedupeMap[m.MessageKey] = m)
  }
  if (newMessages) {
    newMessages.forEach((m) => messageDedupeMap[m.MessageKey] = m)
  }

  const uniqueMessages = Object.values(messageDedupeMap)

  // compareStr String()s its arguments, so optimistic numeric timestamps
  // sort the same way they did in the JS.
  oldMessages[ck] = uniqueMessages.sort((a, b) => _string.compareStr.call(void 0, b.SentTimestamp , a.SentTimestamp ))
  return oldMessages
}

 function patientConversationMessagesReducer (
  state = initialState,
  action,
  globalState,
) {
  switch (action.type) {
    /* patient-ui */
    case _actionCreators2.default.loadPatientConversationByCodeActions.SUCCESS.type:
    case _actionCreators2.default.getPatientConversationMessagesActions.SUCCESS.type: {
      const { payload } = action 
      return combineOldAndNewMessages(
        state,
        payload.PatientConversationMessages,
        Object.keys(payload.PatientConversations)[0] ,
      )
    }

    case _actionCreators2.default.sendPatientConversationMessageActions.REQUEST.type: {
      const { payload, meta } = action 
      return showSend(state, payload, meta.lid, 'sending', globalState)
    }
    case _actionCreators2.default.patientMessageWaitingAction.type: {
      const { Request, lid } = (action ).payload
      return showSend(state, Request, lid, 'waiting', globalState)
    }
    case _actionCreators2.default.sendPatientConversationMessageActions.FAILURE.type: {
      const { meta } = action 
      const conversationKey = Object.keys(state).find(ck =>
        state[ck ].some(m => m.LocalKey === meta.lid)) 
      if (!conversationKey) return state
      return setSendState(state, conversationKey, m => m.LocalKey === meta.lid, 'failed')
    }
    case _actionCreators2.default.patientReactionToggledAction.type: {
      const { ConversationKey, MessageKey, Emoji, Mine } = (action ).payload
      const messages = state[ConversationKey]
      if (!_optionalChain([messages, 'optionalAccess', _6 => _6.some, 'call', _7 => _7(m => m.MessageKey === MessageKey)])) return state
      return {
        ...state,
        [ConversationKey]: messages.map(m => m.MessageKey === MessageKey
          ? { ...m, Reactions: toggleOwnReaction(_nullishCoalesce(m.Reactions, () => ( [])), Emoji, Mine) }
          : m),
      }
    }
    case _actionCreators2.default.patientSendsInterruptedAction.type: {
      const { ConversationKey } = (action ).payload
      return setSendState(state, ConversationKey, m => m.SendState === 'sending', 'failed')
    }
    case _actionCreators2.default.sendPatientConversationFileActions.SUCCESS.type:
    case _actionCreators2.default.sendPatientConversationMessageActions.SUCCESS.type: {
      const { payload, meta } = action 
      // The row this send showed, unless a reload or the server's own
      // notice of the message replaced it first.
      return placeMessage(state, payload.Message, m => m.LocalKey === meta.lid)
    }
    case _actionCreators2.default.incomingPatientMessageNotificationAction.type: {
      return placeMessage(state, (action ).payload)
    }
    case _actionCreators2.default.deletedPatientMessageNotificationAction.type: {
      const deletedMessage = (action ).payload
      if (!(deletedMessage.ConversationKey in state)) {
        return state
      }
      return {
        ...state,
        [deletedMessage.ConversationKey]: state[deletedMessage.ConversationKey].filter(msg => msg.MessageKey !== deletedMessage.MessageKey),
      }
    }
    case _actionCreators2.default.uploadPatientFileActions.REQUEST.type: {
      const { ConversationKey, PatientKey, file } = action.payload 
      const meta = action.meta 

      const FileInfo = {
        LocalMetaData: {
          ...file,
        },
      }
      const newMessage = {
        ConversationKey,
        MessageKey: `temp-${meta.lid}`,
        LocalKey: meta.lid,
        SentTimestamp: new Date().toISOString(),
        FileInfo,
      }

      if (globalState.currentUser.UserKey) {
        newMessage.FromUserKey = globalState.currentUser.UserKey
      } else if (PatientKey) {
        newMessage.FromPatientKey = PatientKey
      }

      const newMessages = state[ConversationKey] ? [newMessage, ...state[ConversationKey]] : [newMessage]
      return {
        ...state,
        [ConversationKey]: newMessages,
      }
    }
    case _actionCreators2.default.uploadPatientFileActions.FAILURE.type: {
      const meta = action.meta 
      const ConversationKey = meta.ConversationKey
      const localKey = meta.lid
      const isTooLarge = _uploadFailure.isUploadTooLarge.call(void 0, action.payload)

      return {
        ...state,
        [ConversationKey]: state[ConversationKey].map(msg => msg.LocalKey === localKey
          ? {
              ...msg,
              FileInfo: {
                ...msg.FileInfo,
                LocalMetaData: {
                  ...msg.FileInfo.LocalMetaData,
                  hasUploadFailed: true,
                  ...(isTooLarge && { isTooLarge }),
                },
              },
            }
          : msg,
        ),
      }
    }
    case _actionCreators2.default.sendPatientConversationFileActions.REQUEST.type: {
      const { payload, meta } = action 
      const conversationKey = payload.ConversationKey
      const localKey = meta.lid
      const Metadata = meta.Metadata
      const currentMessageIndex = state[conversationKey].findIndex(m => m.LocalKey === localKey)

      // Mutates the stored row in place, as the JS did.
      const newMessages = state[conversationKey]
      newMessages[currentMessageIndex].FileInfo.Metadata = Metadata

      return {
        ...state,
        [conversationKey]: newMessages,
      }
    }
    // Pre-existing bug kept as-is: this compares action.type with the action
    // creator itself (not its `.type`), so the case never matches. The cast
    // only lets TypeScript accept that comparison.
    case _actionCreators2.default.sendPatientConversationFileActions.FAILURE : {
      const { payload, meta } = action 
      const { ConversationKey } = payload
      const { lid } = meta

      return {
        ...state,
        [ConversationKey]: state[ConversationKey].map(msg => msg.LocalKey === lid
          ? {
              ...msg,
              FileInfo: {
                ...msg.FileInfo,
                LocalMetaData: {
                  ...msg.FileInfo.LocalMetaData,
                  hasUploadFailed: true,
                },
              },
            }
          : msg,
        ),
      }
    }
  }

  return state
} exports.default = patientConversationMessagesReducer;
